import { graphql } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { Loading } from '../../components/Loading';
import { NoData } from '../../components/Illustrations/NoData';
import { Versions as VersionsCmp } from '../../components/Versions';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';

export const CostVersions_Versions_CostVersions_QueryDocument = graphql(`
  query CostVersions_Versions_Query($originalId: Id!) {
    findAllCostVersionsForOneOriginalId(originalId: $originalId) {
      _id
      createdAt
      creatorId
      automaticMemo
      internalMemo
      memo
      version {
        _id

        code
        codingConfig {
          kind
          strategyId
          ... on CodingConfigManual {
            code
          }
        }

        kind
        typeId
        label
        title
        content
        costMarginId
        statusId
        creatorId
        createdAt
        updaterId
        updatedAt
        ... on FixedCost {
          amount {
            _id
            value
            currencyId
          }
        }
        ... on VariableCost {
          value
        }
      }
    }
  }
`);

interface Props {
  readonly originalId: Id;
}

export const Versions = ({ originalId }: Readonly<Props>) => {
  const { data, isSuccess } = useGraphQLQuery(
    CostVersions_Versions_CostVersions_QueryDocument,
    { originalId },
    { enabled: !!originalId },
  );

  if (isSuccess) {
    const versions = data.findAllCostVersionsForOneOriginalId;

    if (versions.length) {
      return <VersionsCmp versions={versions} />;
    }

    return <NoData />;
  }

  return <Loading />;
};
